import React from 'react';
import { useTheme } from '@theme/useTheme';
import { useAuth } from '@contexts/AuthContext';
import { trackGtmButtonClick } from '@/analytics/gtm';
import googleIcon from '@assets/google.png';

interface ContinueWithProps {
  setErrors: (error: string[]) => void;
}

const ContinueWith: React.FC<ContinueWithProps> = ({ setErrors }) => {
  const { colors } = useTheme();
  const { signInWithGoogle } = useAuth();

  const handleGoogleLogin = async () => {
    try {
      trackGtmButtonClick({
        button_id: 'auth_continue_google',
        section: 'login_modal',
        label: 'Continue with Google',
      });
      setErrors([]); // Clear any existing errors
      await signInWithGoogle();
      // The redirect will handle the rest, so we don't close the modal here
    } catch (error: any) {
      console.error('Google login error:', error);
      setErrors([error.message || 'Google login failed. Please try again.']);
    }
  };


  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t" style={{ borderColor: colors.border }} />
        </div>
        <div className="relative flex justify-center text-sm">
          <span
            className="px-2"
            style={{ 
              color: colors.text,
              backgroundColor: colors.background
            }}
          >
            Or continue with
          </span>
        </div>
      </div>

      <div className="mt-6">
        <button
          onClick={handleGoogleLogin}
          className="w-full inline-flex justify-center items-center py-3 px-4 border rounded-xl shadow-sm text-sm font-medium transition-colors duration-200"
          style={{
            borderColor: colors.border,
            backgroundColor: colors.background,
            color: colors.text
          }}
        >
          <img src={googleIcon} alt="Google" className="h-5 w-5" />
          <span className="ml-2">Continue with Google</span>
        </button>
      </div>
    </div>
  );
};

export default ContinueWith;
